import React from 'react';
import { motion } from 'framer-motion';
import { BatteryWarning, Brain, Scale, Frown } from 'lucide-react';
const painPoints = [{
  icon: Scale,
  title: "El 'botonazo' frustrante",
  description: "Esa inflamación abdominal que aparece aunque comas 'sano', haciendo que tu ropa favorita ya no te cierre."
}, {
  icon: BatteryWarning,
  title: 'Cansancio crónico',
  description: "Despertar cansada a pesar de dormir 8 horas. Sentir que te falta la 'chispa' vital que tenías antes."
}, {
  icon: Brain,
  title: 'Neblina mental',
  description: 'Olvidas nombres, pierdes el hilo de las conversaciones y sientes que tu mente no está tan afilada como antes.'
}, {
  icon: Frown,
  title: 'Cambios de humor',
  description: 'Irritabilidad repentina y una sensación de pérdida de confianza al verte al espejo.'
}];
export function PainPointsSection() {
  return <section className="py-20 bg-white" data-id="element-157">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-158">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-159">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif font-bold text-[#1a4d3e] mb-6" data-id="element-160">
            Lo peor no es la ropa que no te queda...
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-gray-600" data-id="element-161">
            Lo peor es la sensación de que tu cuerpo ya no te responde. Esa
            resignación silenciosa de pensar que "envejecer es engordar" y que
            ya no hay nada que hacer.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-162">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#faf8f5] p-8 rounded-xl border border-gray-100 hover:shadow-lg transition-shadow duration-300" data-id="element-163">
              <div className="w-12 h-12 bg-[#1a4d3e]/10 rounded-full flex items-center justify-center mb-6 text-[#1a4d3e]" data-id="element-164">
                <point.icon size={24} data-id="element-165" />
              </div>
              <h3 className="text-xl font-serif font-bold text-[#2d2d2d] mb-3" data-id="element-166">
                {point.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-167">
                {point.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}